module.exports = __webpack_public_path__ + "static/media/gero-wallet.e67cf08f.svg";